import { Flex } from "@/components/atoms/flex";
import { HistoryPanel } from "@/components/organisms/history";
import { InteractionHistoryListItemDto } from "@/components/organisms/history/types";
import { InteractionCard } from "@/components/organisms/interaction";
import { InteractionHistory } from "@/components/organisms/interactionHistoryWorkspace";
import { useState } from "react";
import { useStyle } from "./style";
import { useResponsiveBreakpoints } from "@/hooks/responsive";
import { HistoryPanelStashActions } from "@/common/stores/nonpersistingStores/history/types";
import { useHistoryPanelStashStore } from "@/common/stores/nonpersistingStores/history/historyPanelStashStore";

export const History = () => {
	const classes = useStyle();

	const stashToggledTab = useHistoryPanelStashStore(
		(state: HistoryPanelStashActions) => state.stashToggledTab
	);

	const restoreToggledTab = useHistoryPanelStashStore(
		(state: HistoryPanelStashActions) => state.restoreToggledTab
	);

	const [interactionHistory, setInteractionHistory] =
		useState<InteractionHistoryListItemDto>();

	const onInteractionHistorSelected = (
		interactionHistory?: InteractionHistoryListItemDto
	) => {
		setInteractionHistory(interactionHistory);

		if (interactionHistory) {
			// Close the open panel to make room for the detail view, remembering it so
			// collapsing the detail view can put it back.
			stashToggledTab();
		}
	};

	const onHistoryPanelExtend = () => {
		restoreToggledTab();
		setInteractionHistory(undefined);
	};

	const { isMobile } = useResponsiveBreakpoints();

	return (
		<>
			<Flex className={classes.container}>
				<HistoryPanel
					onInteractionHistorySelected={onInteractionHistorSelected}
					onHistoryPanelExtend={onHistoryPanelExtend}
				/>
				{interactionHistory && (
					<InteractionHistory historyItem={interactionHistory} />
				)}
			</Flex>
			{!isMobile && <InteractionCard />}
		</>
	);
};
